export default __webpack_public_path__ + "static/media/information-icon-red.2e04e455.svg";